import { MultiLevelPricing, SeatingChart } from '@seatsio/seatsio-types';
import { Language } from '@seatsio/seatsio-react';
import {AvailabilityData} from "./SeatedAvailabilityBar";

export type Discounts = {
  ticket: number;
  newPrice: number;
}[];
export type Selections = {
  id: string;
  ticketType: string;
}[];
export const LanguagesConst = [
  'ar',
  'be',
  'bg',
  'ca',
  'cs',
  'cy',
  'da',
  'de',
  'el',
  'en',
  'es',
  'et',
  'fa',
  'fi',
  'fr',
  'hr',
  'he',
  'hu',
  'it',
  'ja',
  'ku',
  'li',
  'lv',
  'no',
  'nl',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'sr',
  'sv',
  'tr',
  'uk',
  'zh-Hans',
  'zh-Hant',
] as const;

export function isLanguage(value: string): value is Language {
  return LanguagesConst.includes(value as Language);
}

export function validateLanguage(language: string): Language {
  if (isLanguage(language)) {
    return language;
  }
  if (language === 'lt') {
    // https://support.seats.io/en/articles/2074430-translating-embedded-floor-plans-i18n
    // messed up the Lithuanian language code... types, docs and types say it's li, but in reality it's lt which is correct
    return 'lt' as Language;
  }
  return 'en';
}

declare global {
  interface Window {
    $: JQueryStatic;
    seatsioSeatingCharVars?: { 
      seatsAvailability?: AvailabilityData;
      workspaceKey: string;
      eventId: string;
      pricing: MultiLevelPricing[];
      language: string;
      currencySymbol: string;
      holdToken: string;
      chart: SeatingChart;
      selections: Selections;
      showCategoryName: boolean;
      showLegend: boolean;
      ticketsMaxQtys: Record<string, number>;
      transFree: string;
    };
  }
}
